export const CONTENT_TYPES = {
  MOVIE: 'MOVIE',
  SERIE: 'SERIE',
  EPISODE: 'EPISODE',
  BROADCAST: 'BROADCAST',
  SPORT: 'SPORT',
};

export const SHOW_ITEMS_BY_DEFAULT = {
  CAROUSEL: 20,
};
